import React from 'react';
import styles from './style.module.css';

const TreatmentIntroBanner = ({ title, description, quote, backgroundImage }) => {
	return (
		<>
			<div className={styles.navbarSpacer}></div>

			<div
				className={`section mcb-section bg-cover`}
				style={{
					paddingTop: '0px',
					paddingBottom: '0px',
					backgroundImage: `url(${backgroundImage})`,
					backgroundRepeat: 'no-repeat',
					backgroundPosition: 'right bottom',
				}}>
				<div className="section_wrapper mcb-section-inner">
					<div
						className="wrap mcb-wrap one valign-top clearfix"
						style={{
							padding: '30% 0 0%',
						}}>
						<div className="mcb-wrap-inner">
							<div className="column mcb-column one-second column_column">
								<div className={`clearfix ${styles.bannerTextWidth}`}>
									<h2>{title}</h2>
									<hr
										className="no_line"
										style={{
											margin: '0 auto 15px',
										}}
									/>
									<p>{description}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className={styles.pusherDiv}></div>

			<div className="section center bg-theme hrmargin_b_60" style={{ paddingTop: '30px', paddingBottom: '15px' }}>
				<div className="section_wrapper clearfix">
					<div className="items_group clearfix">
						<div className="column_attr">
							<h3 className="text-light" style={{ letterSpacing: '3px' }}>
								{`" ${quote} "`}
							</h3>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default TreatmentIntroBanner;
